import axios from "axios";
import { getURl, getHeaders } from "./core";
import { Util } from "../common/util";

const util = new Util();
export const url = `${getURl()}/auth/v1`;

export function logout() {
  return axios({
    url: `${url}/logout`,
    data: {},
    headers: getHeaders(),
  });
}

export function signin(privateURL, userName, password) {
  return axios({
    method: "POST",
    url: `${url}/login`,
    headers: {
      "Content-Type": "application/json",
      privateURL: privateURL,
      userName: userName,
      password: password,
    },
    data: {},
  });
}

export function signinByMicrosoft(microsoftAccessToken) {
  return axios({
    method: "POST",
    url: `${url}/microsoft_login`,
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${microsoftAccessToken}` // Send Microsoft access token for verification
    },
    data: {},
  });
}

export function changePassword(id, password, currentPassword) {
  return axios({
    method: "PUT",
    url: `${getURl()}/user/v1/reset/password`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${util.getAccessToken()}`,
      id: id,
      currentPassword: currentPassword,
      password: password,
    },
    data: {},
  });
}

export function forgotPassword(email) {
  return axios({
    method: "POST",
    url: `${url}/forgot-password`,
    headers: {
      "Content-Type": "application/json",

    },
    data: JSON.stringify({email})
  });
}
export function validateResetCode(data) {
  return axios({
    method: "POST",
    url: `${url}/verify-reset-code`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data)
  });
}

export function resendResetCode(userId) {
  return axios({
    method: "POST",
    url: `${url}/resend-reset-code`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({userId})
  });
}

export function resetPassword(data) {
  return axios({
    method: "POST",
    url: `${url}/reset-password`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data)
  });
}
